<template>
  <div style="padding-top: 10%;font-size: 14px;font-weight: bold">
    <div style="padding: 0px 30px">
      <van-tag round type="danger"  size="large">移动端上课方式</van-tag>
      <div style="padding-top: 10px">
        1.可在各大应用市场和助手中搜索“筑学网校”进行安装学习
       </div>
      <div style="padding-top: 10px">
        2.登录前需配合客服人员交换验证码进行账号开通
      </div>
    </div>
    <div style="padding: 30px 30px 0px">
      <van-tag round type="danger"  size="large">电脑端上课方式</van-tag>
      <div style="padding-top: 10px">登录<a style="color: orange" href="http://www.zhuxue24.cn" target="_blank">http://www.zhuxue24.cn</a></div>
    </div>
  </div>

</template>

<script>
    export default {
        name: ""
    }
</script>

<style scoped>

</style>
